// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"204":"6263632db8a281c3","697":"97e3a128c3a8bc92"}[chunkId] + ".js";
};